import { useAsyncExecutor, useAsyncExecutor2 } from "async-executor-hook";
import { SelectButton } from "primereact/selectbutton";
import { useContext, useState } from "react";
import { Authorization } from "../../common/AuthorizationCpt";
import { getErrorValueResponse } from "../../common/error/Error";
import LogoBBVAWhite from "../../images/bbva_white.svg";
import LogoBCPWhite from "../../images/bcp_white.svg";
import LoadingSpinner from "../../images/loading_gray.gif";
import LoadingGray from "../../images/loading_gray.gif";
import LogoBBVA from "../../images/logo_BBVA.svg";
import LogoBCP from "../../images/logo_BCP.svg";
import {
  BANKS,
  CURRENCIES,
  getCurrencyObject,
  HTTP_METHODS,
  PaymentModalStates,
} from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { separator } from "../../utils/paymentMethodUtils";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Select from "../Select/Select";
import {
  Container,
  DivIsLoadingIcon,
  IconButton,
  InvoiceContainer,
  InvoicesContainer,
  MainButton,
  PaymentContainer,
  Row,
} from "./CollectionMethodStyles";

function CollectionMethod(props) {
  const {
    updatePaymentState,
    loadUpfront,
    setShowModalUpfront,
    setMessageErrorUpfront,
    updateShowModal,
    onCountRedirect,
    dateUrlQuotationQuoted,
    getQuotationQuotedVolantes,
    volateQuoted,
    quotation_ids,
    clearShoppingCar,
  } = props;
  const [bank, updateBank] = useState(null);
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [useDollars, updateUseDollars] = useContext(CurrencyContext);
  const [currency, updateCurrency] = useState(
    getCurrencyObject(useDollars).value
  );

  const onClick = () => {
    if (!bank || !bank.code) return;
    if (waitingServerResponse) return;
    updateWaitingServerResponse(true);

    saveInvoice.execute({
      quoteIds: quotation_ids,
      bankOption: bank.code,
      paymentCurrency: currency,
      updatePaymentState,
      updateWaitingServerResponse,
    });
  };

  const onCurrencyChange = (e) => {
    updateCurrency(e.target.value);
    updateUseDollars(e.target.value === "pen" ? false : true);
  };

  const saveInvoice = useAsyncExecutor(
    (params: any) => {
      const { quoteIds, bankOption, paymentCurrency } = params;
      const body = {
        quotation_ids: quoteIds,
        upfront_payment_detail: {
          bank_option: bankOption,
          payment_currency: paymentCurrency,
        },
      };
      return networkBackendRequest(
        `/invoices/upfront/`,
        HTTP_METHODS.POST,
        null,
        body
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (data, params: any) => {
        const { bankOption } = params;
        getQuotationQuotedCredit.execute({
          bankOption,
          dataResp: data,
          from_date: dateUrlQuotationQuoted,
        });
      },
      onError: (error) => {
        clearShoppingCar();
        const errorMessage = getErrorValueResponse(error);
        setMessageErrorUpfront(errorMessage);
        setShowModalUpfront(true);
        updateShowModal(false);
      },
    }
  );

  const getQuotationQuotedCredit: any = useAsyncExecutor2(
    (params: any) => {
      return networkBackendRequest(`/quotations/quoted/`, HTTP_METHODS.GET, {
        from_date: params.from_date,
      }).then((resp) => resp.json());
    },
    {
      onSuccess: (data, params) => {
        const count = data.count;
        const { bankOption, dataResp } = params;
        onCountRedirect(count);
        let newPaymentState = {};
        switch (bankOption) {
          case BANKS.bcp.code:
            newPaymentState = PaymentModalStates.BCP;
            break;
          case BANKS.bbva.code:
            newPaymentState = PaymentModalStates.BBVA;
            break;
          default:
            break;
        }
        props.updateDataCode(dataResp);
        updatePaymentState(newPaymentState);
        updateWaitingServerResponse(false);
      },
      onError: (_, params) => {
        const { bankOption, dataResp } = params;
        onCountRedirect(1);
        let newPaymentState = {};
        switch (bankOption) {
          case BANKS.bcp.code:
            newPaymentState = PaymentModalStates.BCP;
            break;
          case BANKS.bbva.code:
            newPaymentState = PaymentModalStates.BBVA;
            break;
          default:
            break;
        }
        props.updateDataCode(dataResp);
        updatePaymentState(newPaymentState);
        updateWaitingServerResponse(false);
      },
    }
  );

  const itemTemplate = (option) => {
    let image = "";
    switch (option.value) {
      case BANKS.bcp.code:
        image = bank?.code === BANKS.bcp.code ? LogoBCPWhite : LogoBCP;
        break;
      case BANKS.bbva.code:
        image = bank?.code === BANKS.bbva.code ? LogoBBVAWhite : LogoBBVA;
        break;
      default:
        break;
    }
    return (
      <IconButton
        selected={bank ? bank.code === BANKS[option.value].code : false}
      >
        <img src={image} alt="bcp" />
      </IconButton>
    );
  };
  return (
    <Container>
      <h1>Forma de pago: Recaudo</h1>
      <h2>Debe pagar la prefactura antes de la medianoche</h2>
      <div className="currency--container">
        <h3>SELECCIONE MONEDA</h3>
        <Select
          className="clickable-element"
          onChange={onCurrencyChange}
          height="4.5rem"
          width="100%"
          arrowPosition="1.6rem"
          value={currency}
        >
          {CURRENCIES.map((currencyElem, index) => (
            <option key={index} value={currencyElem.value}>
              {currencyElem.label}
            </option>
          ))}
        </Select>
      </div>
      <InvoicesContainer>
        {getQuotationQuotedVolantes.isLoading && (
          <DivIsLoadingIcon>
            <img src={LoadingGray} className="icon" alt="Loading screen" />
          </DivIsLoadingIcon>
        )}
        {volateQuoted.map((invoice) => (
          <InvoiceContainer key={invoice.id}>
            <span className="volante-id">{invoice.volanteId}</span>
            <div>
              <p className="invoice-id">{invoice.quotationNum}</p>
              <p className="importer">{invoice.importer}</p>
            </div>
          </InvoiceContainer>
        ))}
      </InvoicesContainer>
      <PaymentContainer>
        <div className="special-row">
          <p>Total factura</p>
          {loadUpfront.isLoading && (
            <img src={LoadingGray} className="icon" alt="Loading screen" />
          )}
          {loadUpfront.isSuccess && (
            <p>
              {currency === "usd"
                ? `$ ${separator(loadUpfront.data.sales_invoice_total.usd)}`
                : `S/ ${separator(loadUpfront.data.sales_invoice_total.pen)}`}
            </p>
          )}
        </div>
      </PaymentContainer>
      <div className="rows-wrapper">
        <Row>
          <div className="row-title">
            <p>Seleccione un banco:</p>
          </div>
          <div className="bank-selectors">
            {loadUpfront.isLoading && (
              <DivIsLoadingIcon>
                <img src={LoadingGray} className="icon" alt="Loading screen" />
              </DivIsLoadingIcon>
            )}

            {loadUpfront.isSuccess && (
              <SelectButton
                className="bank-styles-select-button"
                value={bank?.code}
                options={loadUpfront.data.upfront_bank_options.map((bank) => {
                  return {
                    label: bank.name,
                    value: bank.option,
                  };
                })}
                onChange={(e) => {
                  updateBank(BANKS[e.value]);
                }}
                itemTemplate={itemTemplate}
                disabled={waitingServerResponse}
              />
            )}
          </div>
        </Row>
      </div>
      <div>
        <Authorization actions={["invoice.create_invoice_upfront"]}>
          <MainButton
            onClick={onClick}
            disabled={!bank || waitingServerResponse || volateQuoted.length < 1}
            isLoading={waitingServerResponse}
          >
            {waitingServerResponse && (
              <img
                src={LoadingSpinner}
                className="icon"
                alt="Processing request"
              />
            )}
            Generar código de pago
          </MainButton>
        </Authorization>
      </div>
    </Container>
  );
}

export default CollectionMethod;
